<template>
  <zj-layout-container>
    <zj-layout-main>
      <el-form :model="viewData" class="zj-search-form" :disabled="true">
        <el-form-item label="事件名称：" style="display:inline-block;">
          <el-input
            v-model="viewData.eventName"
            style="width: 23rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件编号：" style="display:inline-block;">
          <el-input v-model="viewData.eventNo" style="width: 23rem"></el-input>
        </el-form-item>
        <el-form-item label="事件级别：" style="display: inline-block">
          <el-input v-model="viewData.verifyEventLevelTranslated" style="width: 23rem"></el-input>
          <!-- <el-select v-model="viewData.verifyEventLevel" style="width: 23rem">
            <el-option
              v-for="item in EventLevelOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="事件类型：" style="display: inline-block">
            <el-input v-model="viewData.verifyEventTypeTranslated" style="width: 23rem"></el-input>
          <!-- <el-select v-model="viewData.verifyEventType" style="width: 23rem">
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="事发地点：" style="display:inline-block;">
          <el-input
            v-model="viewData.eventAddress"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <el-form-item label="事发时间：" style="display:inline-block;">
          <el-date-picker
            style="width: 23rem"
            type="datetime"
            placeholder="选择日期"
            v-model="viewData.happenTime"
            :disabled="EventInfoEdit"
            format="yyyy-MM-dd HH:mm:ss" 
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上报人姓名：" style="display:inline-block;">
          <el-input
            v-model="viewData.reportName"
            style="width: 21.5rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件描述：" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="viewData.eventDesc"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <div style="width: 100%;height: 0; border-top: 1px solid #eee;"></div>
      </el-form>
      <el-form :model="viewData" class="zj-search-form">
        <el-form-item
          label="总结说明："
          style="display:inline-block;margin-top:2rem"
        >
          <el-input
            type="textarea"
            v-model="viewData.summaryDesc"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <el-form-item label="归档描述：" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="viewData.placeFileDesc"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import { getDictionary } from "@/api/src/emergency_common";
import { update } from "@/api/src/emergency_event";
export default {
  data() {
    return {
      EventTypeOptions: [],
      EventLevelOptions: [],
    };
  },
  props: {
    viewData: Object,
  },
  methods: {
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      this.viewData.status = 6;
      update(this.viewData)
        .then((r) => {
          r = r.data;
          this.$emit("search", {});
          this.$emit("ok", {});
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created: function() {
    // getDictionary('emergency_event_level')
    //   .then((eventtypeconf) => {
    //     this.EventTypeOptions = eventtypeconf.data.records;
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });

    // getDictionary('emergency_event_type')
    //   .then((eventlevelconf) => {
    //     this.EventLevelOptions = eventlevelconf.data.records;
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  },
};
</script>
